import { NavLink } from 'react-router-dom'
import getEventAction from '@/routes/projectStages/notifications/lib/helpers/getEventToastData.tsx'
import { SingleIssueEvent } from '@/routes/projectStages/issue/types/issue.ts'
import { Button } from '@/components/ui/Button.tsx'
type PropsT = {
  event: SingleIssueEvent
  projectStageIri: string
}

export default function NotificationToastLink({ event, projectStageIri }: PropsT) {
  const action = getEventAction(event, projectStageIri)

  if (!action || !action.link) return null

  return (
    <Button className={`h-7`} variant={`outline`} size={`sm`} asChild={true}>
      <NavLink to={action.link} className={`flex items-center gap-2`}>
        {action.icon}
        <span className={`text-xs leading-7`}>{action.linkLabel}</span>
      </NavLink>
    </Button>
  )
}
